var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("" + (_vm.open ? 'open' : '')),attrs:{"id":"ccp-wrapper"}},[_c('div',{staticClass:"ccp",attrs:{"id":"containerDiv"}})])}
var staticRenderFns = []

export { render, staticRenderFns }